import QueryDatabase from "./QueryDatabase";

export const getRecipesData = async (serverProps, userID, recipes, setRecipes, setServerAccess, startIndex = 0, amount = 200) => {
    setServerAccess(0);
    await QueryDatabase({
        user: userID,
        table: "recipes",
        method: 2,
        constraints: {
            start: startIndex,
            amount: amount
        },
        filter: "",
        data: "",
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort

    }).then((data) => {
        if (data === -1)
            setServerAccess(-1)
        else {
            const newRecipesArray = data.map(datum => {
                const Recipe_Instructions = datum.Recipe_Instructions ? datum.Recipe_Instructions : "[]";
                return {
                    Recipe_ID: datum.Recipe_ID,
                    Recipe_Name: datum.Recipe_Name,
                    Recipe_Time: datum.Recipe_Time,
                    Recipe_Difficulty: datum.Recipe_Difficulty,
                    Recipe_Ingredients: JSON.parse(datum.Recipe_Ingredients),
                    Recipe_Instructions
                };
            })
            setServerAccess(1)
            setRecipes(newRecipesArray);
        }
    });
}

export const deleteRecipe = async (serverProps, userID, recipes, setRecipes, plans, setPlans, recipe) => {
    
    await QueryDatabase({
        user: userID,
        table: "recipes",
        method: 1,
        filter: "",
        data: recipe.Recipe_ID,
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data.affectedRows === 1) {
            const newRecipesArray = recipes.filter((recipeElement) => {
                return recipeElement.Recipe_ID !== recipe.Recipe_ID;
            })
            setRecipes(newRecipesArray);
            const newPlansArray = plans.filter((planElement) => {
                return planElement.Recipe_ID !== recipe.Recipe_ID
            })
            setPlans(newPlansArray)
        }
    })
}

export const addRecipe = async (serverProps, userID, recipes, setRecipes, plans, setPlans, recipe) => {
    QueryDatabase({
        user: userID,
        table: "recipes",
        method: 0,//if recipe_ID already exists, update via put, otherwise add via post
        filter: "",
        data: recipe,
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data.affectedRows === 1) {
            if (data.insertId) {//if the recipe was inserted rather than updated, ignore all the recipe ingredient faffery
                const newRecipesArray = [...recipes, {
                    ...recipe,
                    Recipe_ID: data.insertId
                }];
                setRecipes(newRecipesArray)
            }
        }
    })
}

export const submitRecipe = async (serverProps, userID, recipes, setRecipes, plans, setPlans, recipe) => {
    if (recipe.Recipe_ID < 0 || (!recipe.Recipe_ID && recipe.Recipe_ID !== 0))
        addRecipe(serverProps, userID, recipes, setRecipes, plans, setPlans, recipe)
    else
        updateRecipe(serverProps, userID, recipes, setRecipes, plans, setPlans, recipe)
}

export const updateRecipe = async (serverProps, userID, recipes, setRecipes, plans, setPlans, recipe) => {
    //todo figure out how to make this update work
    await QueryDatabase({
        user: userID,
        table: "recipes",
        method: 5,
        filter: "",
        data: recipe,
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data.result.affectedRows === 1) {

            let newRecipesArray = null;
            let newRecipe = { ...recipe };//create a new recipe identical to the input recipe. place up here so the plan data section can get at the amended recipe data
            
            if (data.result3) {
                let idIndex = 0;
                let newRecipeIngredients = newRecipe.Recipe_Ingredients.map((element) => {
                //change the Recipe_Ingredients list so that inserted ingredients have their new IDs and update ingredients have their "changed" flag removed
                    if (!element.Recipe_Ingredient_ID) {//check if the recipe ingredient doesn't have an id, then assign one in order from the insert ids list
                        idIndex++;
                        return {
                            ...element,
                            Recipe_Ingredient_ID:data.result3.insertIds[idIndex - 1]
                        }
                    }
                    if (element.changed)
                        return {
                            ...element,
                            changed: false
                        }
                    else return element
                });
                newRecipe.Recipe_Ingredients = newRecipeIngredients
            }
            newRecipesArray = recipes.map((element) => {
                if (element.Recipe_ID === recipe.Recipe_ID)
                    return newRecipe;
                else
                    return element
            })
            setRecipes(newRecipesArray)

            //now for the fun part - updating the recipe data in the planner
            const newPlanData = plans.map((plan) => {
                    
                if (plan.Recipe_ID === newRecipe.Recipe_ID) {
                    const newRecipeIngredients = newRecipe.Recipe_Ingredients.map((Recipe_Ingredient) => {
                        const planRecipeIngredient = plan.Recipe_Ingredients.find((element) => element.Recipe_Ingredient_ID === Recipe_Ingredient.Recipe_Ingredient_ID)
                        if (planRecipeIngredient)
                            return {
                                ...Recipe_Ingredient,
                                Ingredient_ID: planRecipeIngredient.Ingredient_ID,
                                Item_ID: planRecipeIngredient.Item_ID
                            }
                        else return Recipe_Ingredient
                    })
                    return {
                        ...plan,
                        Recipe_Name: newRecipe.Recipe_Name,
                        Recipe_Ingredients: newRecipeIngredients
                    }
                }
                else return plan;
            })
            setPlans(newPlanData)
        }
    })
}